import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import ListRoutingGuides from './ListRoutingGuides';
import CreateRouteForm from './CreateRouteForm';
// import CreateDCCRouteForm from './CreateDCCRouteForm'; // Not needed since we are using AddEditDCCRouteForm
// import EditDCCRouteForm from './EditDCCRouteForm'; // Not needed since we are using AddEditDCCRouteForm
import EditRouteForm from './EditRouteForm';
import AddEditDCCRouteForm from './AddEditDCCRouteForm';
import RoutingGuideLayout from './RoutingGuideLayout';
import RoutingGuide from './index.js'; // Assuming this is the initial selection page

const RoutingGuideRoutes = () => {
  const [successMessage, setSuccessMessage] = useState('');

  const fetchRoutes = async () => {
    // Placeholder function for fetching routes
    // Replace with actual logic as needed
  };

  return (
    <RoutingGuideLayout>
      {successMessage && <div className="alert alert-success">{successMessage}</div>}
      <Routes>
        <Route path="/" element={<RoutingGuide />} />
        <Route path="list" element={<ListRoutingGuides />} />
        <Route path="create" element={<CreateRouteForm setSuccessMessage={setSuccessMessage} />} />
        <Route path="create/dcc" element={<AddEditDCCRouteForm setSuccessMessage={setSuccessMessage} />} />
        <Route path="edit/:routing_guide_id" element={<EditRouteForm setSuccessMessage={setSuccessMessage} fetchRoutes={fetchRoutes} />} />
        <Route path="edit/dcc/:routing_guide_id" element={<AddEditDCCRouteForm setSuccessMessage={setSuccessMessage} fetchRoutes={fetchRoutes} />} />
      </Routes>
    </RoutingGuideLayout>
  );
};

export default RoutingGuideRoutes;

